<template>

  <!-- scrollable list: fills the remaining height and scrolls on overflow -->
  <div
    ref="scroller"
    class="conversation-list flex-fill overflow-auto"
    @scroll="onScroll">

    <ConversationListSkeleton
      v-if="loading && !conversations.length"
      :slim="slim" />

    <ConversationListEmpty
      v-else-if="!conversations.length"
      :slim="slim" />

    <template v-else>
      <div :class="{ 'mt-1': slim }">
        <ConversationListItem
          v-for="(conversation, index) in conversations"
          :key="conversation._id"
          :conversation="conversation"
          :active="conversation._id === selectedId"
          :slim="slim"
          :index="index"
          @select="$emit('select', $event)" />
      </div>

      <div
        v-if="loadingMore"
        class="text-center text-muted py-2">
        <i class="fa-solid fa-circle-notch fa-spin"></i>
      </div>
    </template>

  </div>

</template>

<script>
import ConversationListItem from './ConversationListItem'
import ConversationListSkeleton from './ConversationListSkeleton'
import ConversationListEmpty from './ConversationListEmpty'

export default {
  name: 'ConversationList',
  components: {
    ConversationListItem,
    ConversationListSkeleton,
    ConversationListEmpty
  },
  props: {
    conversations: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    selectedId: {
      type: String,
      default: null
    },
    // narrow column: the items become numbered circles
    slim: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /*
    onScroll
    infinite scroll: loads the next page once the user is close to the bottom
    */
    onScroll () {
      if (!this.hasMore || this.loadingMore) {
        return
      }
      const el = this.$refs.scroller
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 120) {
        this.$emit('load-more')
      }
    }
  }
}
</script>

<style scoped>
/* a flex child needs min-height: 0 to be allowed to shrink and scroll */
.conversation-list {
  min-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/sidebar/ConversationList.vue